var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29412 2.82353C3.03422 2.82353 2.82353 3.03422 2.82353 3.29412V5.17647C2.82353 5.95617 2.19146 6.58824 1.41176 6.58824C0.632069 6.58824 0 5.95617 0 5.17647V3.29412C0 1.47483 1.47483 0 3.29412 0H5.17647C5.95617 0 6.58824 0.632069 6.58824 1.41176C6.58824 2.19146 5.95617 2.82353 5.17647 2.82353H3.29412Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7059 2.82353C12.9658 2.82353 13.1765 3.03422 13.1765 3.29412V5.17647C13.1765 5.95617 13.8085 6.58824 14.5882 6.58824C15.3679 6.58824 16 5.95617 16 5.17647V3.29412C16 1.47483 14.5252 0 12.7059 0H10.8235C10.0438 0 9.41176 0.632069 9.41176 1.41176C9.41176 2.19146 10.0438 2.82353 10.8235 2.82353H12.7059Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29412 13.1765C3.03422 13.1765 2.82353 12.9658 2.82353 12.7059V10.3529C2.82353 9.57325 2.19146 8.94118 1.41176 8.94118C0.632069 8.94118 0 9.57325 0 10.3529V12.7059C0 14.5252 1.47482 16 3.29412 16H5.17647C5.95617 16 6.58824 15.3679 6.58824 14.5882C6.58824 13.8085 5.95617 13.1765 5.17647 13.1765H3.29412Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7059 13.1765C12.9658 13.1765 13.1765 12.9658 13.1765 12.7059V10.8235C13.1765 10.0438 13.8085 9.41176 14.5882 9.41176C15.3679 9.41176 16 10.0438 16 10.8235V12.7059C16 14.5252 14.5252 16 12.7059 16H10.8235C10.0438 16 9.41176 15.3679 9.41176 14.5882C9.41176 13.8085 10.0438 13.1765 10.8235 13.1765H12.7059Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/fullScreen.74a05bdb6817297cb7501e131316b1d4.svg";
export { ForwardRef as ReactComponent };